module.exports = __webpack_public_path__ + "img/dash.2cdabbca.svg";